import MessageType from './MessageType';

export default MessageType;